
if (!customElements.get('component-region')) {
  customElements.define(
    'component-region',
    class HeaderRegion extends HTMLElement {
      isCloseing = false;

      constructor() {
        super();
      }

      createItemTemplate(region, iconSrc, selectedLabel, label, path) {
        return `
          <div class="component-region-item" data-region-item>
            <a href="${path}" data-region="${region}" data-region-selected-label="${selectedLabel}" data-region-path="${path}">
              <div class="component-region-item-box">
                <div class="component-region-item-icon" data-region-item-icon>
                ` + (iconSrc ? `<img src="${iconSrc}" width="22.6" height="16" alt="${label}">` : '') + `
                </div>
                <div class="component-region-item-text" data-region-item-text>${label}</div>
              </div>
            </a>
          </div>
        `;
      }

      connectedCallback() {
        this.json = JSON.parse(this.getAttribute('data-json'));

        if (!this.json) return;
        const itemsTemplate = this.json.map((v) => this.createItemTemplate(v.region, v.iconSrc, v.selected_label, v.label, v.path));
        const previousElement = this.previousElementSibling;
        const iconExpandSlot = previousElement.tagName == "TEMPLATE" ? previousElement.content.querySelector('[name="icon-expand"]')?.innerHTML :
          `<svg
              class="icon icon-region-expand"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99997 8.95697L1.79297 4.74997L2.49997 4.04297L5.99997 7.54297L9.49997 4.04297L10.207 4.74997L5.99997 8.95697Z" fill="black"/>
            </svg>
        `;

        this.innerHTML = `
          <details>
            <summary>
              <div class="component-region">
                <div class="component-region-item-box">
                  <div class="component-region-item-icon" data-region-item-icon></div>
                  <div class="component-region-item-text" data-region-item-text></div>
                  ${iconExpandSlot}
                </div>
              </div>
            </summary>
            <div class="component-region__container">
              <div class="component-region__card">
                <div class="component-region-list">
                  ${itemsTemplate.join('')}
                </div>
              </div>
            </div>
          </details>
        `;


        this.mainDetailsToggle = this.querySelector('details');
        this.elements = {
          HeaderAccount: this.querySelector('button'),
          summary: this.querySelector('summary'),
        };
        this.init();
      }

      init() {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));

        this.elements.summary.addEventListener('click', (e) => {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.closeDetails();
          } else {
            this.openDetails();
          }
          // Check if the event target is a link
          // if (e.target.tagName.toLowerCase() == 'a') {
          //     // Allow the default action
          //     return;
          // }
          e.preventDefault();
        });
        document.addEventListener('click', (e) => {
          const el = e.target.closest('component-region');
          if (!el) this.closeDetails();
        });
        this.addEventListener('mouseleave', () => {
          this.closeDetails();
        });

        this.initRegion();
      }

      initRegion() {
        // From old region code
        // [data-region-selected-label]: Display name for selected
        const component = this;
        const summary = this.elements.summary;
        const regions = ['/', '/en-ca/'];
        const path =
          (location.pathname &&
            location.pathname.match(/\/en-\w{2}/) &&
            location.pathname.match(/\/en-\w{2}/)[0]) ||
          '/';
        const region = regions.find((r) => r.indexOf(path) !== -1);
        const currentRegionElement = component.querySelector(`[data-region-path="${region}"]`);
        try {
          if (currentRegionElement) {
            summary.querySelector('[data-region-item-icon]').innerHTML =
              currentRegionElement.querySelector('[data-region-item-icon]').innerHTML;
            summary.querySelector('[data-region-item-text]').innerHTML = currentRegionElement
              .getAttribute('data-region-selected-label');
          }
        } catch (error) {
          console.error(error);
        }
        for (const item of component.querySelectorAll('[data-region-item] a')) {
          item.addEventListener('click', (e) => {
            location.href = item.getAttribute('data-region-path');
            e.preventDefault();
          });
        }
      }
      openDetails() {
        if (this.isCloseing) return;
        this.mainDetailsToggle.setAttribute('open', '');
      }

      closeDetails() {
        if (this.isCloseing) return;
        this.isCloseing = true;
        this.mainDetailsToggle.classList.add('closing')
        setTimeout(() => {
          this.mainDetailsToggle.removeAttribute('open');
          this.isCloseing = false;
          this.mainDetailsToggle.classList.remove('closing')
        }, 300);
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.summary.focus();
        }
      }
    }
  );
}